import type { GitlabRole } from '../lib/api.ts';

const ROLE_LABEL: Record<GitlabRole, string> = {
  guest: 'Guest',
  reporter: 'Reporter',
  developer: 'Developer',
  maintainer: 'Maintainer',
  owner: 'Owner',
};

export function RoleBadge({ role }: { role: GitlabRole | null }) {
  if (!role) return null;
  return <span className={`badge repo-role-badge badge-role-${role}`}>{ROLE_LABEL[role]}</span>;
}
